export enum FeatureFlags {
  ALERT_CLINICAL_OUTREACH_TO_MD_TRIAGE = 'alert-clinical-outreach-to-md-triage',
  ADJUDICATE_CASH_ORDERS = 'adjudicate-cash-orders',
  ALLOW_ERX_REJECTION_FROM_CUSTOMER_UNASSIGNED = 'Allow-Erx-Rejection-From-Customer-Unassigned',
  ALLOW_ERX_REJECTION_FROM_PATIENT_MATCH = 'Allow-Erx-Rejection-From-Patient-Match',
  ALLOW_FORWARDS_FOR_ALTO_TRANSFERS = 'allow-forwards-for-alto-transfers',
  ALLOW_LINEAR_BARCODE_SCANNING = 'allow-linear-barcode-scanning',
  AUTO_E1_CHECK = 'auto-E1-check',
  AUTO_FIX_QUANTITY = 'auto-fix-quantity',
  AUTO_GENERATE_PRESCRIPTION = 'auto-generate-prescription',
  AUTO_PA_INITIATION_TRIGGER = 'auto-pa-initiation-trigger',
  AUTO_REJECT_BAD_ADDRESS = 'Auto-Reject-Bad-Address',
  AUTO_REJECT_CONTROLLED_SUBSTANCES_LARGE_DAYS_SUPPLY = 'Auto-Reject-Controlled-Substances-Large-Days-Supply',
  AUTO_REJECT_INSUFFICIENT_QUANTITY_WHEN_NO_SWAPPABLE_RX = 'auto-reject-insufficient-quantity-when-no-swappable-rx',
  AUTO_APPLY_OCC1_FOR_BNL_COPAY = 'auto-apply-occ1-for-bausch-lomb-copay',
  AUTO_REJECT_INSURANCE_ORDERS_BASED_ON_CLAIM_REJECT = 'auto-reject-insurance-orders-based-on-claim-reject',
  AUTO_REJECT_ESCRIPT_NPI_NDC_COMBINATION = 'auto-reject-escript-npi-ndc-combination',
  AUTO_REJECT_ORDER_CONTROLLED_SUBSTANCE_BY_STATE = 'auto-reject-order-controlled-substance-by-state',
  AUTO_REVERSE_REBILL_EVOUCHER_CLAIMS = 'auto-reverse-rebill-evoucher-claims',
  AUTO_REVERSE_REBILL_EVOUCHER_CLAIMS_ON_SECONDARY_REJECT = 'auto-reverse-rebill-evoucher-claims-on-secondary-reject',
  AUTO_TRIAGE_COPAY_CHANGE_FOR_UNLINKED_ORDERS = 'auto-triage-copay-change-for-unlinked-orders',
  AUTO_TRIAGE_FAILED_DUR_CHECKS = 'auto-triage-failed-dur-checks',
  AUTO_TRIAGE_FORWARD_PICK_NEEDS_REPLENISHMENT = 'auto-triage-forward-pick-needs-replenishment',
  AUTO_TRIAGE_FOR_OUT_OF_STOCK = 'auto-triage-for-out-of-stock',
  AUTO_TRIAGE_MEDICARE_PRESCRIPTION_PAYMENT_PLAN = 'auto-triage-medicare-prescription-payment-plan',
  AUTO_TRIAGE_NO_SHELF_LOCATION = 'auto-triage-no-shelf-location',
  AUTO_TRIAGE_REFILL_PERCENTAGE = 'Auto-Triage-Refill-Percentage',
  AUTO_TRIAGE_REPLACEMENT_ORDERS = 'auto-triage-replacement-orders',
  AUTO_TRIAGE_REQUIRE_SUPERVISING_MD = 'auto-triage-require-supervising-md',
  AUTO_TRIAGE_SPECIALTY_CONSULT = 'auto-triage-specialty-consult',
  AUTO_TRIAGE_UNABLE_CONFIRM_COPAY = 'auto-triage-unable-confirm-copay',
  AUTO_UPDATE_DUR_INPUT_MAPPINGS = 'auto-update-durinputmappings',
  BLOCK_REROUTE_STATES_REQUIRING_RX_TRANSFER = 'block-reroute-states-requiring-rx-transfer',
  BLOCK_SECONDARY_CLAIM_BASED_ON_PRIMARY = 'block-secondary-claim-based-on-primary',
  BYPASS_ORG_CHECK_FOR_INVENTORY = 'bypass-org-check-for-inventory',
  CHECK_GOODRX_GOLD_TRANSFERS = 'Check-GoodRx-Gold-Transfers',
  CLAIM_JUMPER_ERRORS_FOR_COPAY_AUTO_TRIAGE = 'claim-jumper-errors-for-copay-auto-triage',
  CLAIM_REJECT_CODES_FOR_COPAY_AUTO_TRIAGE = 'claim-reject-codes-for-copay-auto-triage',
  COMPARE_ORDER_VS_CLAIM_COPAY = 'compare-order-vs-claim-copay',
  COMPARE_STRIPE_VS_CLAIM_COPAY = 'compare-stripe-vs-claim-copay',
  COMPLETE_COPAY_REQUEST_FILL_MUTATION_RETURN_ONLY_ID = 'complete-copay-request-fill-mutation-return-only-id',
  COPY_MESSAGES_FROM_CORE_TO_TPOS = 'copy-messages-from-core-to-tpos',
  COVER_MY_MEDS_PRIOR_AUTH = 'cover-my-meds-prior-auth',
  CREATE_ROUTING_RULES = 'create-routing-rules',
  CUSTOMER_EDI_PRICING = 'customer-edi-pricing',
  CUSTOMERS_NOT_REQUIRING_PRECHECK = 'Customers-Not-Requiring-Precheck',
  DECOUPLE_CRITICAL_NOTES = 'decouple-critical-notes-popup',
  DEFER_BATCH_AUTOMATION = 'defer-batch-automation',
  DISCONTINUE_DUPLICATE_PRESCRIPTIONS = 'discontinue-duplicate-prescriptions',
  DISPLAY_NEW_COPAY_CHECK_BUTTON = 'display-new-copay-check-button',
  DISPLAY_STRIPE_ID_IN_UI = 'display-stripe-id-in-ui',
  DISPLAY_TRANSFER_OUT_WIDGET_TPOS_HOMEPAGE = 'display-transfer-out-widget-tpos-homepage',
  DUPLICATE_RX_BANNER = 'duplicate-rx-banner-pv1',
  ELIGIBILITY_CHECK_TIMEOUT = 'eligibility-check-timeout',
  ENABLE_AUTO_SHIPPING_LABEL_PRINTING = 'enable-auto-shipping-label-printing',
  ENABLE_BALANCE_IN_FLIGHT = 'Enable-Balance-In-Flight',
  ENABLE_BULK_ACTIONS = 'enable-bulk-actions',
  ENABLE_FIFO_LOCATION_FALLBACK = 'enable-fifo-location-fallback',
  ENABLE_FILL_IN_ALTO_BASED_ON_STATE = 'enable-fill-in-alto-based-on-state',
  ENABLE_IL_PATIENT_EDUCATION_PACKING_MATERIAL = 'enable-il-patient-education-packing-material',
  ENABLE_LOT_ACCURACY_MODAL_GTIN_SCANNING = 'enable-lot-accuracy-modal-gtin-scanning',
  ENABLE_MEDISPAN_API_V3 = 'enable-medispan-api-v3',
  ENABLE_MUTATIONS_BY_ROLE = 'enable-mutations-by-role',
  ENABLE_NEW_PRESCRIPTION_CREATE_V2 = 'Enable-New-Prescription-V2',
  ENABLE_ORDER_SPLITTING = 'enable-order-splitting',
  ENABLE_PACKING_MATERIALS_ACCURACY_SCANNING = 'Enable-Packing-Materials-Accuracy-Scanning',
  ENABLE_PET_PATIENT_INFO_IN_PARATA_XML = 'enable-pet-patient-info-in-parata-xml',
  ENABLE_REQUEST_CLARIFICATION_BUTTON = 'Enable-Request-Clarification-Button',
  ENABLE_SHIPPING_METHOD_CHANGE_FOR_HAZARDOUS_OTC = 'enable-shipping-method-change-for-hazardous-otc',
  ERX_INTAKE_HOLD_ON_PATIENT_MISMATCH = 'e-rx-intake-hold-on-patient-mismatch',
  ERX_INTAKE_NEW_PROFILE_ON_PATIENT_MISMATCH = 'e-rx-intake-new-profile-on-patient-mismatch',
  ERX_INTAKE_VALIDATION_DAYS_SUPPLY = 'e-rx-intake-validation-days-supply',
  ERX_INTAKE_VALIDATION_DISCONTINUED_NDC = 'e-rx-intake-validation-discontinued-ndc',
  ERX_INTAKE_VALIDATION_INNER_OUTER_NDC_MISMATCH = 'e-rx-intake-validation-inner-outer-ndc-mismatch',
  ERX_INTAKE_VALIDATION_INCONSISTENT_DAYS_SUPPLY = 'e-rx-intake-validation-inconsistent-days-supply',
  ERX_INTAKE_VALIDATION_INVALID_MEDICATION_QUANTITY = 'e-rx-intake-validation-invalid-medication-quantity',
  ERX_INTAKE_VALIDATION_INVALID_UOM = 'e-rx-intake-validation-invalid-uom',
  ERX_INTAKE_VALIDATION_INVALID_UOM_GENERAL = 'e-rx-intake-validation-invalid-uom-general',
  ERX_INTAKE_VALIDATION_MED_QUANTITY_MLS = 'e-rx-intake-validation-med-quantity-mls',
  ERX_INTAKE_VALIDATION_NON_NDC_FORMAT = 'e-rx-intake-validation-non-ndc-format',
  ERX_INTAKE_VALIDATION_UNBREAKABLE_QUANTITY = 'e-rx-intake-validation-unbreakable-quantity',
  ERX_REQUIRE_PATIENT_PHONE = 'require-patient-phone-erx',
  ES_INDEX_ALLERGIES = 'Es-Index-Allergies',
  COPAY_REQUEST_NDC_SUBSTITUTION_MAP = 'copay-request-ndc-substitution-map',
  EVOUCHER_OVERRIDE_AUTOMATION = 'evoucher-override-automation',
  HANDLE_DUPLICATE_COPAY_REQUESTS = 'handle-duplicate-copay-requests',
  IGNORE_DUR_RESULTS = 'ignore-dur-results',
  INSURANCE_INTAKE_ENABLED = 'insurance-intake-enabled',
  INTERNAL_EXTERNAL_TRANSFER_AFTER_PV1 = 'internal-external-transfer-after-pv1',
  KEEP_ESCRIPTS_IN_TPOS = 'Keep-Escripts-In-Tpos',
  OVERWRITE_SUBSTITUTION_ON_ESCRIPT = 'Overwrite-Substitution-On-Escript',
  PA_CODE_OVERRIDE = 'pa-code-override',
  PA_PENDING_WARNING = 'pa-pending-warning',
  PA_RENEWAL_QUEUE = 'pa-renewal-queue',
  PA_STATUS_CHECK_BUTTON = 'pa-status-check-button',
  PA_FAX_PRESCRIBER_BUTTON = 'pa-fax-prescriber-button',
  PATIENT_RESPONSIBILITY_AMOUNT_TYPE = 'patient-responsibility-amount-type-on-occ-8',
  PAYMENT_INTENT_CAPTURE = 'payment-intent-capture',
  PAYMENT_INTENT_DUPLICATE_PID_ACTION = 'payment-intent-duplicate-pid-action',
  PAYMENT_INTENT_EXPIRATION_ACTION = 'payment-intent-expiration-action',
  PAYMENT_INTENT_EXPIRATION_CHECK = 'payment-intent-expiration-check',
  PBM_VALIDATION = 'pbm-validation',
  PRESCRIPTION_SIG_MAPPING = 'prescription-sig-mapping',
  PRESCRIPTION_SIG_MAPPING_MOUNJARO = 'prescription-sig-mapping-mounjaro',
  PRESCRIPTION_SIG_MAPPING_ZEPBOUND_KWIK_PEN = 'prescription-sig-mapping-zepbound-kwik-pen',
  PRINT_OTC_PICK_SLIPS_ON_RX_LABEL = 'print-otc-pick-slips-on-rx-label',
  PUBLISH_TO_HASH_EXCHANGE = 'publish-to-hash-exchange',
  PUBLISH_TO_TOPIC_EXCHANGE = 'publish-to-topic-exchange',
  PV1_INTERFACE_CONSISTENCY = 'pv-1-interface-consistency',
  PV1_HIDE_WEIGHT_BY_CUSTOMER = 'pv-1-hide-weight-by-customer',
  PV2_CLAIM_AGE_THRESHOLD = 'pv-2-claim-age-threshold',
  DISPENSING_LOCATION_REQUIRES_NY_LICENSE = 'dispensing-location-requires-ny-license',
  REMOVE_REJECTED_SECONDARY_CLAIM = 'remove-rejected-secondary-claim',
  REQUIRE_USER_TO_OUTBOUND_SCAN_DURING_PACKING = 'require-user-to-outbound-scan-during-packing',
  RETRY_FAILED_DUR_CHECKS = 'retry-failed-dur-checks',
  RX_LABEL_CUSTOMER_CONFIGURATION = 'rx-label-customer-configuration',
  RX_LABEL_REDESIGN = 'rx-label-redesign',
  RX_CHANGE_REQUEST_LABEL_CUSTOMER_CONFIGURATION = 'rx-change-request-label-customer-configuration',
  RX_RENEWAL_REQUEST_LABEL_CUSTOMER_CONFIGURATION = 'rx-renewal-request-label-customer-configuration',
  SEND_FILLS_TO_PRESCRIPTION_SERVICE = 'send-fills-to-prescription-service',
  SEND_RENEWALS_TO_INTAKE_PHARMACY = 'send-renewals-to-intake-pharmacy',
  SHOW_ALERT_WHEN_MISSING_DEA_VALUE = 'show-alert-when-missing-dea-value',
  SITE_PERFORMANCE_STATUS = 'site-performance-status',
  SHOULD_ADD_KANGAROO_MAILER_FOR_TEMPERATURE_SENSITIVE_MEDS = 'should-add-kangaroo-mailer-for-temperature-sensitive-meds',
  SHOULD_AUTO_FIX_DAYS_SUPPLY_PRECHECK = 'should-auto-fix-days-supply-precheck',
  SHOULD_AUTO_FIX_QUANTITY_PRECHECK = 'should-auto-fix-quantity-precheck',
  SHOULD_TURN_OFF_FAILED_CLAIM = 'should-turn-off-failed-claim',
  SHOULD_VALIDATE_PRESCRIPTION_ON_ORDER = 'should-validate-prescription-on-order',
  SKIP_CLAIM_JUMPER_COPAYS = 'skip-claim-jumper-copays',
  SKIP_PV1_TEMP_DISREGARD_SCREENING_NDCS = 'skip-pv1-temp-disregard-screening-ndcs',
  SKIP_PV_1 = 'Skip-Pv-1',
  SKIP_PV_1_DISREGARD_WEIGHT_FROM_SURVEY = 'skip-pv1-disregard-weight-from-survey',
  SKIP_PV_1_EVALUATE_THERAP_EQUIVALENT_MEDICATIONS = 'skip-pv1-evaluate-therap-equivalent-medications',
  SKIP_REQUEST_SHIPPING_LABEL_CONFIRM_PV2 = 'skip-request-shipping-label-confirm-pv2',
  STRIPE_ITEMIZED_RECEIPT = 'stripe-itemized-receipt',
  SUBMIT_SECONDARY_OCC_3_IF_PRIMARY_REJECTS = 'submit-secondary-occ-3-if-primary-rejects',
  SUBMIT_SECONDARY_OCC_3_RERUN_ONLY_SECONDARY_CLAIM = 'submit-secondary-occ-3-rerun-only-secondary-claim',
  TEMP_ADD_OTC_RX_LABEL_TO_QUEUES = 'temp-add-otc-rx-label-to-queues',
  TEMP_ADJUSTMENT_VALIDATION_ACTIVE = 'temp-adjustment-validation-active',
  TEMP_ADJUSTMENT_VALIDATION_FRONTEND_MODAL_ACTIVE = 'temp-adjustment-validation-frontend-modal-active',
  TEMP_ALLOW_FAILED_REVERSALS_SEND_BACK_TO_ADJUDICATION = 'temp-allow-failed-reversals-send-back-to-adjudication',
  TEMP_ALLOW_ORAL_SYRINGE_PACKING_MATERIAL = 'temp-allow-oral-syringe-packing-material',
  TEMP_BLOCK_CONFIRM_PV_ON_LOADING_CRITICAL_NOTES = 'temp-block-confirm-pv-on-loading-critical-notes',
  TEMP_BLOCK_SECONDARY_CLAIM_USE_RESPONSE_FLOW = 'temp-block-secondary-claim-use-response-flow',
  TEMP_CANCEL_OTC_BUTTON = 'temp-cancel-otc-button',
  TEMP_CLAIM_JUMPER_OPTIMIZED_CLONING = 'temp-claim-jumper-optimized-cloning',
  TEMP_COMPLETE_COPAY_FILL_WHEN_SECONDARY_CLAIM_WITH_OCC3_WAS_PAID = 'temp-complete-copay-fill-when-secondary-claim-with-occ3-was-paid',
  TEMP_CONFIRM_PV1_REQUIRES_DUR_CHECK = 'temp-confirm-pv1-requires-dur-check',
  TEMP_COPAY_REASON_MAPPING_ENHANCEMENT = 'temp-copay-reason-mapping-enhancement',
  TEMP_CREATE_FILL_USING_UPDATE_INSTEAD_OF_SAVE = 'temp-create-fill-using-update-instead-of-save',
  TEMP_CREATE_FILL_WITH_NDC_DATA_FROM_PRESCRIBED = 'temp-create-fill-with-ndc-data-from-prescriber',
  TEMP_CREATE_OTC_ADJUDICATION_FILLS = 'temp-create-otc-adjudication-fills',
  TEMP_DISPLAY_PATIENT_CONSENT_ON_TRIAGE_PAGES = 'temp-display-patient-consent-on-triage-pages',
  TEMP_DUPLICATE_RX_MODAL = 'temp-duplicate-rx-modal',
  TEMP_DUR_SCREENING_FILTER_DUP_NDC_FROM_RXS = 'temp-dur-screening-filter-dup-ndc-from-rxs',
  TEMP_DUR_SCREENING_UPDATE_INSTEAD_OF_SAVE = 'temp-dur-screening-update-instead-of-save',
  TEMP_DUR_TOKEN_MATCHING = 'temp-dur-token-matching',
  TEMP_ENABLE_ARKANSAS_PATIENT_OUTREACH_TRIAGE_CHECK = 'temp-enable-arkansas-patient-outreach-triage-check',
  TEMP_ENABLE_ADDING_EXTRA_PACKING_MATERIALS = 'temp-enable-adding-extra-packing-materials',
  TEMP_ENABLE_CASH_ORDER_ROUTING = 'temp-enable-cash-order-routing',
  TEMP_ENABLE_COPAY_REJECT_LIMIT = 'temp-enable-copay-reject-limit',
  TEMP_ENABLE_CROSS_ORG_PRESCRIPTION_OPERATIONS = 'temp-enable-cross-org-prescription-operations',
  TEMP_ENABLE_LOCATION_ORG_VALIDATION = 'temp-enable-location-org-validation',
  TEMP_ENABLE_MULTIPLE_DRUG_COVERAGE_STATUS_CODES = 'temp-enable-multiple-drug-coverage-status-codes',
  TEMP_ENABLE_PA_EXPIRES_ON = 'temp-enable-pa-expires-on',
  TEMP_ENABLE_SATURDAY_DELIVERY_ELIGIBILITY_FILTER = 'temp-enable-saturday-delivery-eligibility-filter',
  TEMP_ENABLE_WAREHOUSE_SHELF_LOCATIONS_SORT = 'temp-enable-warehouse-shelf-locations-sort',
  TEMP_ENHANCE_PATIENT_SEARCH = 'temp-enhance-patient-search',
  TEMP_ESI_E1_HOLD_COPAY = 'temp-esi-e1-hold-copay',
  TEMP_ESI_HOLD_COPAY_CHECK = 'temp-esi-hold-copay-check',
  TEMP_ESI_SWAP_RX = 'temp-esi-swap-rx',
  TEMP_FILL_REQUEST_PAST_PV_1_CHECK = 'temp-fill-request-past-pv-1-check',
  TEMP_FILTERS_RESET_PAGINATION = 'temp-filters-reset-pagination',
  TEMP_FILTER_INACTIVE_NDCS_FOR_NDC_SUBSTITUTIONS = 'temp-filter-inactive-ndcs-for-ndc-substitutions',
  TEMP_FIX_E1_CHECK_RULE = 'temp-fix-e1-check-rule',
  TEMP_FORCE_CREATE_FULL_FILL = 'temp-force-create-full-fill',
  TEMP_GET_FULFILLMENT_ORDER_HINT = 'temp-get-fulfillment-order-hint',
  TEMP_GET_FULFILLMENT_ORDER_USE_HAS_NO_PRINT_MATCH_V2 = 'temp-get-fulfillment-order-use-has-no-print-match-v2',
  TEMP_GET_FULFILLMENT_ORDER_USE_SECONDARY_READ_PREFERENCE = 'temp-get-fulfillment-order-use-secondary-read-preference',
  TEMP_GET_FULFILLMENT_ORDERS_TIMEOUT_ENABLED = 'temp-get-fulfillment-orders-timeout-enabled',
  TEMP_GET_FULFILMENT_ORDERS_2 = 'temp-get-fulfilment-orders-2',
  TEMP_GOODRX_MANUAL_ENROLLMENT = 'temp-goodrx-manual-enrollment',
  TEMP_HANDLE_DUPLICATE_PA_RESPONSES = 'temp-handle-duplicate-pa-responses',
  TEMP_HIDE_CONSENT_ON_PV1 = 'temp-hide-consent-on-pv1',
  TEMP_HIDE_REFILLS_WRITEEN_FIELD_RX_REVIEW = 'temp-hide-refills-written-field-rx-review',
  TEMP_HIGHLIGHT_FIRST_FILL = 'temp-highlight-first-fill',
  TEMP_HIGHLIGHT_PV1_DIFFERENCES = 'temp-highlight-pv1-differences',
  TEMP_INITIATE_PA_STATIC_BUTTON = 'temp-initiate-pa-static-button',
  TEMP_INSURANCE_PLAN_TYPE_FIELD = 'temp-insurance-plan-type-field',
  TEMP_IMPLEMENT_REVERSE_INSURANCE_ORDER = 'temp-implement-reverse-insurance-order',
  TEMP_LINK_ORDERS_AND_COPAYS_WITH_SAME_RX_TOKEN = 'Temp-link-orders-and-copays-with-same-rx-token',
  TEMP_LOG_FFS_INVENTORY = 'Temp-Log-FFS-Inventory',
  TEMP_LOGS_DATALOADER = 'temp-logs-dataloader',
  TEMP_MANUAL_PA_STATUS_WEBHOOK = 'temp-manual-PA-status-webhook',
  TEMP_MATCH_ORDER_INSURANCES_TO_COPAY = 'temp-match-order-insurances-to-copay',
  TEMP_MIGRATE_TO_RX_RENEWALS_COLLECTION = 'temp-migrate-to-rx-renewals-collection',
  TEMP_NEW_FIELDS_ON_SENT_REVERSALS_AND_CLAIMS = 'temp-new-fields-on-sent-reversals-and-claims',
  TEMP_OTC_ADJUDICATION_HIDE_RX_COMPONENT = 'temp-otc-adjudication-hide-rx-component',
  TEMP_OTC_ONLY_PERMISSIONS = 'temp-otc-only-permissions',
  TEMP_PA_TERMINAL_STATUS_APPROVED_DENIED = 'temp-pa-terminal-status-approved-denied',
  TEMP_PAYMENT_INTENT_UNIQUE_ID_CHECK = 'temp-payment-intent-unique-id-check',
  TEMP_PAYMENT_CAPTURE_PARTIAL_REJECTED_BATCH = 'temp-payment-capture-partial-rejected-batch',
  TEMP_PREVENT_SUBSTITUTION_ON_PACK_SIZE_MISMATCH = 'temp-prevent-substitution-on-pack-size-mismatch',
  TEMP_PRIOR_AUTHORIZATION_QUEUE_NEWEST_TO_OLDEST = 'temp-prior-authorization-queue-newest-to-oldest',
  TEMP_PRIORITIZE_REVERSE_REBILL_CLAIM_JUMPER = 'temp-prioritize-reverse-rebill-claim-jumper',
  TEMP_REJECT_CONFLICTING_DAW_NDC = 'temp-reject-conflicting-daw-ndc',
  TEMP_REJECT_MEDICARE_PAYMENT_PLAN = 'temp-reject-medicare-payment-plan',
  TEMP_REMOVE_MACHINE_AFTER_MOVING_TO_MANUAL_AUTO = 'temp-remove-machine-after-moving-to-manual-auto',
  TEMP_SAVE_ANNOTATIONS_RX_IMAGE = 'temp-save-annotations-rx-image',
  TEMP_SEND_PRIOR_AUTHORIZATION_CALLBACKS = 'temp-send-prior-authorization-callbacks',
  TEMP_STRIPE_CHARGE_VALIDATION_TAX = 'temp-stripe-charge-validation-tax',
  TEMP_STRIPE_CHARGE_VALIDATION_SHIPPING = 'temp-stripe-charge-validation-shipping',
  TEMP_SUPPORT_CSA_NOTES = 'temp-support-csa-notes',
  TEMP_SUPPRESS_OTHER_PAYER_ID = 'temp-suppress-otherPayerId',
  TEMP_TRIAGE_MEDICARE_PAYMENT_PLAN = 'temp-triage-medicare-payment-plan',
  TEMP_UNBREAKABLE_PACK_DEFINITION = 'temp-unbreakable-pack-definition',
  TEMP_UPDATE_OTC_FILTER_BUTTON_LOGIC = 'temp-update-OTC-filter-button-logic',
  TEMP_UPDATE_UNAVAILABLE_TO_ORDER_REJECTION_CODE = 'temp-update-unavailable-to-order-rejection-code',
  TEMP_USE_ANY_AB_SUBS_WHEN_NO_GENERICS_AVAILABLE = 'temp-use-any-AB-subs-when-no-generics-available',
  TEMP_USE_COPAY_MESSAGE_V2 = 'temp-use-copay-message-v2',
  TEMP_USE_DUR_TOKEN_MAPPINGS = 'temp-use-dur-token-mappings',
  TEMP_USE_GRAPHQL_QUERY_IN_COMPONENT_FILE = 'temp-use-graphql-query-in-component-file',
  TEMP_USE_NEW_RELAYHEALTH_URL = 'temp-use-new-relayhealth-url',
  TEMP_USE_NEW_SAVE_CLAIM_QUERY = 'temp-use-new-save-claim-query',
  TEMP_USE_REUSABLE_CHECK_COPAY_AMOUNT_FUNCTION = 'temp-use-reusable-check-copay-amount-function',
  TEMP_USE_SESSION_IN_CLAIM_JUMPER = 'temp-use-session-in-claim-jumper',
  TEMP_USE_SUPERVISOR_TEMPLATE = 'temp-use-supervisor-template',
  TEMP_VALIDATE_CLAIM_RESPONSE_EDI = 'temp-validate-claim-response-edi',
  TEMP_ZOOKEEPER_USE_NET_PROTOCOL = 'temp-zookeeper-use-net-protocol',
  TPOS_DASHBOARD_DESIGN_V2 = 'tpos-dashboard-design-v2',
  TPOS_DASHBOARD_MULTISELECTORS = 'enable-fulfillment-dashboard-multiselectors',
  TPOS_PV1_DESIGN_V2 = 'tpos-pv1-design-v2',
  TRANSFER_HISTORY_IMAGE_NEW_VERSION = 'transfer-history-image-new-version',
  TRIAGE_COPAY_CHANGE_LINKED_ORDERS = 'triage-copay-change-linked-orders',
  TRIAGE_ORDERS_FOR_DUPLICATE_PRESCRIPTIONS = 'triage-orders-for-duplicate-prescriptions',
  USE_COPAY_PAYMENT_VALIDATION = 'use-copay-payment-validation',
  USE_COPAY_VALIDATION_ON_RESOLVE_PATIENT_OUTREACH_TRIAGE = 'use-copay-validation-on-resolve-patient-outreach-triage',
  USE_DIRECT_TRANSFER_PRESCRIBER_DURING_TAKEOVER = 'use-direct-transfer-prescriber-during-takeover',
  USE_EXACT_PATIENT_SEARCH_OR_CREATE = 'Use-Exact-Patient-Search-Create-Core-To-Tpos',
  USE_INTERNAL_TRANSFER_HISTORY = 'use-internal-transfer-history',
  USE_JANUS_FORMULARY_STATUS = 'Use-Janus-Formulary-Status',
  USE_MONGO_ATLAS_AS_DUR_SEARCH_SOURCE_AUTOMATIC = 'use-mongo-atlas-as-dur-search-source-automatic',
  USE_MONGO_ATLAS_AS_DUR_SEARCH_SOURCE_MANUAL = 'use-mongo-atlas-as-dur-search-source-manual',
  USE_PATIENT_SERVICE_FOR_PATIENT_UPDATES = 'use-patient-service-for-patient-updates',
  USE_RX_CLARIFICATION_STATUS = 'use-rx-clarification-status',
  USE_SEARCH_ICD10_BY_CODE = 'use-search-icd10-by-code',
  USE_SIMPLIFIED_MEDICATION_SEARCH = 'use-simplified-medication-search',
  USE_SKU_WAREHOUSE_LOCATION = 'use-sku-warehouse-location',
  USE_TECSYS_INVENTORY_OTC = 'use-tecsys-inventory-otc',
  USE_V2_ESCRIPT_AUTH = 'use-v2-escript-auth',
  VALIDATE_INVENTORY_INFO_ON_ADJUST = 'validate-inventory-info-on-adjust',
  WARN_ON_PA_DENIAL_HISTORY = 'warn-on-pa-denial-history',
  ASSIGN_SUPERVISOR_TO_PRESCRIBER_PRACTICE_ON_DTV2 = 'assign-supervisor-to-prescriber-practice-on-dtv2',
  USE_STATE_LICENSES_FROM_DTV2 = 'use-state-licenses-from-dtv2',
  AUTO_REJECT_INVALID_NDCS = 'auto-reject-invalid-ndcs',
  FORWARD_ERX_TO_ALTOOS = 'forward-erx-to-altoos',
}

export interface FeatureFlag<T> {
  key: FeatureFlags
  value: T
}
